import script from "./NavigationBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationBar.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationBar.vue?vue&type=style&index=0&id=60c1be4f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c1be4f"]])

export default __exports__